import ACTION_TYPES from '../actions/actionTypes'

export default (state, action) => {

    switch (action.type) {

        case ACTION_TYPES.FETCH_KAIZEN_CATEGORIES:
            return { ...state, kaizenCategories: action.payload }
        case ACTION_TYPES.FETCH_KAIZEN_AREA:
            return { ...state, kaizenArea: action.payload }
        case ACTION_TYPES.FETCH_KAIZEN_CELL:
            return { ...state, kaizenCell: action.payload }
        case ACTION_TYPES.FETCH_KAIZEN_USER_DATA:
            return { ...state, userData: action.payload }
        case ACTION_TYPES.FETCH_KAIZEN_ALL_USERS:
            return { ...state, allUsers: action.payload }
        case ACTION_TYPES.FETCH_MANAGER_DETAILS:
            return { ...state, managerDetails: action.payload }
        case ACTION_TYPES.UPDATE_KAIZEN_STATUS:
            return { ...state, status: action.payload }
        case ACTION_TYPES.ADD_KAIZEN_RAISE_CI:
            return { ...state, status: action.payload }
        case ACTION_TYPES.GET_KAIZEN_CI_LIST:
            return { ...state, ciList: action.payload }
        case ACTION_TYPES.FETCH_KAIZEN_SITE_FOCAL_INFO:
            return { ...state, siteFocalInfo: action.payload }
        case ACTION_TYPES.FETCH_KAIZEN_DATA_BY_ID:
            return { ...state, kaizenData: action.payload }
        case ACTION_TYPES.FETCH_ADMIN_NOMINATED_KAIZEN_DATA:
            return { ...state, allNominated: action.payload }
        case ACTION_TYPES.MANAGE_ADMIN_NOMINATED_KAIZEN_DATA:
            return { ...state, allNominated: action.payload }
        case ACTION_TYPES.FETCH_KAIZEN_ADMIN_DELETE_LIST:
            return { ...state, kaizenAdminList: action.payload }
        default:
            return state;
    }
};